import { GroupOption } from '@/presentation/components/generalizations/enrolments-table-group-selector/selectors/group-option';
import { GroupOptionsEnums } from '@/models/group-options-enums';

export class InvoiceGroupOption extends GroupOption {
	public get displayText(): string {
		return 'Invoice';
	}
	public equals(option: GroupOption): boolean {
		return option instanceof InvoiceGroupOption;
	}
	public getHashKey(): GroupOptionsEnums {
		return GroupOptionsEnums.INVOICE;
	}
}
